/*
 * Atomz menu - the navigation as a drawer, on a phone.
 *
 * The nav was a third row under the logo and the search field, scrolling
 * sideways, so Brands and Our stores sat off the right edge with nothing
 * saying they were there. A shopper does not discover a horizontal scroll
 * whose end they cannot see.
 *
 * It is the same nav. The drawer is the desktop row, restyled by CSS at
 * phone widths, so there is one list and one source rather than a second
 * menu to keep in step. What this file adds is opening it, closing it, and
 * the plus that expands a mega panel in place -- on a desktop that panel
 * drops on hover, which a touch screen has no equivalent for.
 *
 * FAILURE MODE: no script, no drawer. The nav is then what it has always
 * been underneath, a row of links, and every one of them still works.
 */
(function () {
  'use strict';

  var OPEN = 'az-menu-open';

  function init() {
    var nav = document.getElementById('az-nav');
    var btn = document.querySelector('[data-az-menu]');
    if (!nav || !btn) return;

    var scrim = nav.parentNode.querySelector('.az-nav__scrim');

    function open() {
      document.body.classList.add(OPEN);
      btn.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = nav.querySelector('[data-az-menu-close]');
      if (first) first.focus();
    }

    function close() {
      document.body.classList.remove(OPEN);
      btn.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true;
      document.body.style.overflow = '';
      btn.focus();
    }

    function isOpen() {
      return document.body.classList.contains(OPEN);
    }

    btn.addEventListener('click', function () {
      if (isOpen()) close(); else open();
    });

    Array.prototype.forEach.call(
      nav.parentNode.querySelectorAll('[data-az-menu-close]'),
      function (el) { el.addEventListener('click', close); }
    );

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    /*
     * A panel that drops on hover has no touch equivalent, so inside the
     * drawer each mega item gets a control that expands it in place. Built
     * here rather than in Liquid because it exists only for the drawer: on a
     * desktop the same markup is a hover panel and this button would be a
     * stray plus beside a nav link.
     */
    Array.prototype.forEach.call(
      nav.querySelectorAll('.az-nav__item--mega'),
      function (item) {
        var panel = item.querySelector('.az-mega');
        var link = item.querySelector('.az-nav__link');
        if (!panel || !link) return;

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'az-nav__expand';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Show ' + link.textContent.trim());
        item.insertBefore(toggle, panel);

        toggle.addEventListener('click', function () {
          var on = !item.classList.contains('is-open');
          item.classList.toggle('is-open', on);
          toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }
    );

    /* A drawer left open behind a widening viewport becomes an off-screen
       panel holding the body scroll lock. */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 749 && isOpen()) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
